import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/tag/:tagId',
    name: 'tag',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "interest" */ './views/interest.vue')
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.interestId = parseInt(routeTo.params.tagId)
        handleRoute()
        function handleRoute() {
          return Promise.all([
            store.dispatch('interests/fetchStatusUpdates', {
              interestId: routeTo.params.tagId,
              type: 'tag',
            }),
            store.dispatch('interests/fetchInterest', {
              interestId: routeTo.params.tagId,
              type: 'tags',
            }),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Products' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      statusUpdates: route.meta.tmp.statusUpdates,
      interest: route.meta.tmp.interest,
      interestId: parseInt(route.meta.tmp.interestId, 10),
      // showDefaultCompanyPicker: route.meta.tmp.showDefaultCompanyPicker,
    }),
  },
  {
    path: '/organization/:organizationId',
    name: 'organization',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "interest" */ './views/interest.vue')
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.interestId = parseInt(routeTo.params.organizationId)
        handleRoute()
        function handleRoute() {
          return Promise.all([
            store.dispatch('interests/fetchStatusUpdates', {
              interestId: routeTo.params.organizationId,
              type: 'charity-organization',
            }),
            store.dispatch('interests/fetchInterest', {
              interestId: routeTo.params.organizationId,
              type: 'charity-organization',
            }),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Products' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      statusUpdates: route.meta.tmp.statusUpdates,
      interest: route.meta.tmp.interest,
      interestId: parseInt(route.meta.tmp.interestId, 10),
      // showDefaultCompanyPicker: route.meta.tmp.showDefaultCompanyPicker,
    }),
  },
  {
    path: '/cause/:causeId',
    name: 'cause',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "interest" */ './views/interest.vue')
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.interestId = parseInt(routeTo.params.causeId)
        handleRoute()
        function handleRoute() {
          return Promise.all([
            store.dispatch('interests/fetchStatusUpdates', {
              interestId: routeTo.params.causeId,
              type: 'charity-organization',
            }),
            store.dispatch('interests/fetchInterest', {
              interestId: routeTo.params.causeId,
              type: 'tags',
            }),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Products' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      statusUpdates: route.meta.tmp.statusUpdates,
      interest: route.meta.tmp.interest,
      interestId: parseInt(route.meta.tmp.interestId, 10),
      // showDefaultCompanyPicker: route.meta.tmp.showDefaultCompanyPicker,
    }),
  },
]
